import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AppLayout from '../layouts/AppLayout.vue'

import AdminLayout from '../layouts/AdminLayout.vue'

const routes: Array<RouteRecordRaw> = [
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'home' },
    children: [
      {
        name: 'home',
        path: 'home',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'sponsored',
        path: 'sponsored',
        component: () => import('../pages/sponsored/SponsoredPage.vue'),
      },
      {
        name: 'fanpage',
        path: 'fanpage',
        component: () => import('../pages/fanpage/FanpagePage.vue'),
      },
      {
        name: 'group',
        path: 'group',
        component: () => import('../pages/group/GroupPage.vue'),
      },
      {
        name: 'profile',
        path: 'profile',
        component: () => import('../pages/profile/ProfilePage.vue'),
      },
      {
        name: 'user-details',
        path: 'uid/:uid',
        component: () => import('../pages/uid/UserDetailsPage.vue'),
      },
      {
        name: 'payment-success',
        path: 'success',
        component: () => import('../pages/payment/PaymentSuccessPage.vue'),
      },
    ],
  },
  {
    name: 'admin-panel',
    path: '/admin',
    component: AdminLayout,
    redirect: { name: 'admin-dashboard' },
    meta: { requiresAuth: true },
    children: [
      {
        name: 'admin-dashboard',
        path: '',
        component: () => import('../pages/admin-panel/AdminDashboardPage.vue'),
      },
      {
        name: 'admin-payments',
        path: 'payments',
        component: () => import('../pages/admin-panel/AdminPaymentsPage.vue'),
      },
      {
        name: 'admin-url-requests',
        path: 'url-requests',
        component: () => import('../pages/admin-panel/AdminUrlRequestsPage.vue'),
      },
      {
        name: 'admin-pricing-plans',
        path: 'pricing-plans',
        component: () => import('../pages/admin-panel/AdminPricingPlansPage.vue'),
      },
      {
        name: 'admin-change-password',
        path: 'change-password',
        component: () => import('../pages/admin-panel/AdminChangePasswordPage.vue'),
      },
      {
        name: 'admin-create-user',
        path: 'create-user',
        component: () => import('../pages/admin-panel/AdminCreateUserPage.vue'),
      },
    ],
  },
  {
    name: 'admin-login',
    path: '/admin/login',
    component: () => import('../pages/admin-panel/AdminLoginPage.vue'),
    meta: { requiresGuest: true },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'home' },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      // Use nextTick to ensure DOM is ready
      return new Promise((resolve) => {
        setTimeout(() => {
          const el = document.querySelector(to.hash)
          if (el) {
            resolve({ el, behavior: 'smooth' })
          } else {
            resolve({ top: 0, behavior: 'smooth' })
          }
        }, 100)
      })
    } else {
      return { top: 0, behavior: 'smooth' }
    }
  },
  routes,
})

// Navigation guard for admin routes
router.beforeEach(async (to, from, next) => {
  const { useAdminAuthStore } = await import('../stores/admin-auth-store')
  const adminAuthStore = useAdminAuthStore()

  adminAuthStore.initAuth()

  if (to.meta.requiresAuth && !adminAuthStore.isAuthenticated()) {
    next({ name: 'admin-login' })
  } else if (to.meta.requiresGuest && adminAuthStore.isAuthenticated()) {
    next({ name: 'admin-dashboard' })
  } else {
    next()
  }
})

export default router
